<template>
    <div id="business-stakeholders-control">
        <div class="vx-row">
            <!-- <div class="vx-col sm:w-full md:w-8/12">
                <div id="rep-legal-stakeholder-control">
                    <p class="bold black mb-1">¿El representante legal es accionista?</p> 
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/2 lg:w-1/6 mb-8 mt-2" v-for="(item, index) in replegal_options"
                            :key="index">
                            <rg-radio @change="repLegalControl()" class="w-full" groupName="replegalStakeholder" :label="item.label" :value="item.value"
                                v-model="replegal_value" />
                        </div>
                    </div> 
                </div>
            </div> -->
            <div class="vx-col w-full">
                <div id="stakeholders_table"> 
                    <div id="stakeholders_table">
                        <vs-button type="border" class="mb-4" @click.stop="addStakeholder()">Agregar accionista</vs-button>
                        <br><small>*Para PF es Fecha de nacimiento, PM es fecha de constitución.</small>
                        <!-- {{ stakeholders }} -->
                          <!-- {{ personal_business }} -->
                        <vs-table
                            ref="table"
                            noDataText="No hay datos disponibles"
                            :data="stakeholders"
                            stripe>
                            <template slot="thead">
                                <vs-th v-for="(col, idx) in columns" v-bind:key="idx"
                                    :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                    <vs-td>{{ stakeholderName(tr) }}</vs-td>
                                    <vs-td>{{ getAddress(tr) || "Dirección no proporcionada" }}</vs-td>
                                    <vs-td>{{ tr.share_percentage * 10}}</vs-td>
                                    <vs-td>{{ isRepLegal(tr) ? 'Sí' : 'No' }}</vs-td>
                                    <vs-td>{{ getDate(tr) }}</vs-td>
                                    <vs-td v-if="!isRepLegal(tr)">
                                        <div class="flex">
                                            <vx-tooltip
                                            text="Eliminar accionista">
                                                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="removeItemRequest(tr)" />
                                            </vx-tooltip>
                                            <vx-tooltip
                                                text="Editar accionista">
                                                <feather-icon  icon="EditIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="ml-6" @click.stop="setEditForm(tr)" />
                                            </vx-tooltip>
                                            <div v-if="tr.is_guarantee" class="flex">
                                                <vx-tooltip
                                                    text="Enviar recordatorio de verificación de identidad solicitada.">
                                                    <feather-icon  icon="UserIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(tr, 1)" />
                                                </vx-tooltip>
                                                <!-- <vx-tooltip
                                                    text="Enviar recordatorio de consulta cdc solicitada.">
                                                    <feather-icon  icon="DollarSignIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(tr, 2)" />
                                                </vx-tooltip> -->
                                            </div>
                                        </div>
                                    </vs-td>
                                    <vs-td v-else>
                                        <vx-tooltip
                                            text="Editar accionista">
                                            <feather-icon  icon="EditIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="ml-6" @click.stop="setEditForm(tr)" />
                                        </vx-tooltip>
                                        <div v-if="tr.is_guarantee" class="flex">
                                            <vx-tooltip
                                                text="Enviar recordatorio de verificación de identidad solicitada.">
                                                <feather-icon  icon="UserIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(tr, 1)" />
                                            </vx-tooltip>
                                            <!-- <vx-tooltip
                                                text="Enviar recordatorio de consulta cdc solicitada.">
                                                <feather-icon  icon="DollarSignIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(tr, 2)" />
                                            </vx-tooltip> -->
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                            

                        </vs-table>
                    </div>
                </div>
            </div>
        </div>

        <vs-popup
            :title="isEditing ? 'Editar accionista' : 'Agregar accionista'"
            :active.sync="showFormPrompt">
            <stakeholder-form 
                ref="stakeholderForm" 
                :stakeholder="selectedStakeholder" 
                :repLegalIsMainUser="false" 
                :hasMoreThanFourStakeholders="false"
                :otherSharePercentage="otherSharePercentage"
                :isEditing="isEditing"
                :collections="collections"
                @updated="stakeholderUpdated"
                :need-actions="true"
                @close="showFormPrompt = false"
            ></stakeholder-form>
        </vs-popup>

        <vs-popup
            title="Representante legal"
            :active.sync="showRepLegalInfo">
            <div class="p-3">
                <p class="mb-3">Ingrese el porcentaje de acciones que posee el representante legal en la empresa.</p>
                <vs-input
                    type="number"
                    max="100"
                    min="1"
                    class="sm:w-full md:w-1/2"
                    label="Porcentaje de acciones"
                    name="share_percentage"
                    v-validate="repLegalPercentageRules"
                    v-model.number="repLegalPercentage"
                    :danger="hasError('share_percentage')"
                    :danger-text="errorText('share_percentage')"
                    :success="isSuccess('share_percentage')"
                    icon-pack="feather"/>

                <div class="w-full mt-4">
                    <vs-button class="mt-4" color="dark" @click="showRepLegalInfo = false, replegal_value = null, repLegalPercentage = null">Cancelar</vs-button>
                    <vs-button class="mt-4 ml-4" :disabled="repLegalPercentage == null" @click="setRepLegalAsStakeholder()">Guardar</vs-button>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>
    import StakeholderForm from '../../../views/applicant/loan-requests/components/shared_components/StakeholderForm.vue';
    import dateHelper from "@mixins/dateHelper.js";
    const columnDefinitions = [
        { title: "NOMBRE", key: "complete_name", sortable: true },
        { title: "DIRECCIÓN", key: "address", sortable: true },
        { title: "% PARTICIPACIÓN", key: "participation", sortable: true },
        { title: "¿ES REPRESENTANTE LEGAL?", key: "isRepLegal", sortable: true },
        { title: "FECHA*", key: "date", sortable: true },
        { title: "", key: "", sortable: false },
    ];
    export default {
        name: "BusinessStakeholdersControl",
        mixins: [dateHelper],
        components: {
            StakeholderForm,
        },
        props: {
            loanData: {
                type: Object,
                required: true,
            },
        },
        data: () => ({
            replegal_value: null,
            replegal_options: [
                { label: "Sí", value: 1 },
                { label: "No", value: 0 },
            ],
            hasStakeHolders: false,
            columns: columnDefinitions,
            selectedStakeholder: {},
            isEditing: false,
            showFormPrompt: false,
            stakeholdersArray: [],
            isMounted: false,
            collections: {
                countries: [],
                states: []
            },
            showRepLegalInfo: false,
            requiredRules: "required|numeric|min:1|max:100",
            repLegalPercentage: null
        }),
        created() {
            this.getCollections();

            // Revisa sí el rep legal es accionista 
            for(let sh of this.stakeholders) {
                if(this.isRepLegal(sh)) {
                    this.replegal_value = 1;
                    break;
                }
            }
        },
        watch: {
            // replegal_value(newVal) {
            //     if(newVal == 1) {
            //         if(this.hasStakeholders) {
            //             this.showRepLegalInfo = true;
            //         }
            //     } else {
            //         this.setRepLegalAsStakeholder();
            //     }
            // },
        },
        computed: {
            stakeholders() {
                return this.loanData?.client?.user?.business?.stakeholders || [];
            },
            personal_business() {
                return this.loanData?.client?.user?.business?.personal || null;
            },
            // Suma del porcentaje de acciones de los accionistas, sin contar el que se edita
            // (en BD se guarda dividido entre 10)
            otherSharePercentage() {
                const selectedId = this.selectedStakeholder?.id;
                const others = this.stakeholders
                    .filter(s => selectedId == null || s.id != selectedId)
                    .reduce((sum, s) => sum + (Number(s.share_percentage) || 0) * 10, 0);
                return Math.round(others * 100) / 100;
            },
            repLegalPercentageRules() {
                const total = this.stakeholders.reduce((sum, s) => sum + (Number(s.share_percentage) || 0) * 10, 0);
                const max = Math.max(0, Math.round((100 - total) * 100) / 100);
                return `required|numeric|min_value:1|max_value:${max}`;
            }
        },
        methods: {
            repLegalControl() {
                if(this.replegal_value == 1) {
                    this.showRepLegalInfo = true;
                } else {
                    this.setRepLegalAsStakeholder();

                }
            },
            isRepLegal(tr) {
                const ppId = this.personal_business.id;

                return tr.stakeholder_pp_id == ppId;
            },
            removeItemRequest(testimony){
                this.selectedStakeholder = testimony;

                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: 'Eliminar Accionista',
                    text: `¿Realmente desea eliminar al accionista ${this.stakeholderName(testimony)}?`,
                    acceptText: "Eliminar",
                    cancelText: 'Cancelar',
                    accept: this.doRemoveItem
                });
            },
            async doRemoveItem(){
                this.showLoading(true);
                try {
                    await axios.delete(`/api/stakeholder/delete/${this.selectedStakeholder.id}/stakeholder`);
                    this.$emit("updated");
                }
                catch (error) {
                    this.showLoading(false);
                    this.failedOperationNotif();
                    console.log(error);
                    // this.warn(error);
                }
                this.showLoading(false);
            },
            async getCollections(){
                try {
                    let collectionsObjects = ['countriesList', 'statesList'];
                    let params = "with[]=" + collectionsObjects.join("&with[]=");
                    let res = await this.publicApiGet(`/api/v1/forms/getPublicFormCollections?${params}`);
                    let colls = res.data;
                    colls.statesList.forEach(opt => {
                        this.collections.states.push({value: parseInt(opt.id), label: opt.name});
                    });
                    colls.countriesList.forEach(opt => {
                        this.collections.countries.push({value: parseInt(opt.id), label: opt.name}); //conversion a sintaxis de vx-select
                    });
                }
                catch (e) {
                    console.error("Error fetching collections for BusinessStakeholdersControl", e);
                }
            },
            addStakeholder() {
                this.selectedStakeholder = {
                    role_type: "Accionista",
                    role: "stakeholder",
                    profile: {
                        first_name: null,
                        second_name: null,
                        last_name_1: null,
                        last_name_2: null,
                        curp: null,
                        rfc: null,
                        birth_date: null,
                        gender: null,
                        birth_state: null,
                        citizenship: 700,
                        phone: {
                            phone: null,
                            country_calling_code: "+52",
                        },
                        phone_id: null,
                    },
                    share_percentage: null,
                    email: null,
                    person_type: null,
                    isValid: true,
                    is_max_percentage: null,
                    id: null,
                    loan_id: this.loanData.id
                    
                };
                this.showFormPrompt = true;
            },
            stakeholderName(stakeholder) {
                if(stakeholder.stakeholder_bp_id != null) {
                    return stakeholder.business_profile.name;
                } else if(stakeholder.stakeholder_pp_id != null) {
                    const personal = stakeholder.personal_profile; 
                    return `${personal.first_name} ${personal.second_name||""} ${personal.last_name_1} ${personal.last_name_2||""}`;
                } else {
                    return "NO TIENE PERFIL";
                }
            },
            getAddress(stakeholder) {
                let address = null;
                if(stakeholder.stakeholder_bp_id != null) {
                    const business = stakeholder.business_profile;
                    address = business.address;
                } else if(stakeholder.stakeholder_pp_id != null) {
                    const personal = stakeholder.personal_profile; 
                    address = personal.address;
                } else {
                    return "NO TIENE PERFIL";
                }

                if(address != null && address.neighborhood_id != null) {
                    return address.full_address;
                } else {
                    return "Dirección no proporcionada";
                }
            },
            setEditForm(tr) {
                // console.log(tr);
                const isMoral = tr.stakeholder_bp_id != null;
                const isValid = tr.stakeholder_bp_id != null || tr.stakeholder_pp_id != null
                this.selectedStakeholder = {
                    role_type: "Accionista",
                    role: "stakeholder",
                    profile: {
                        first_name: null,
                        second_name: null,
                        last_name_1: null,
                        last_name_2: null,
                        curp: null,
                        rfc: null,
                        birth_date: null,
                        gender: null,
                        birth_state: null,
                        citizenship: 700,
                        phone: {
                            phone: null,
                            country_calling_code: "+52",
                        },
                        phone_id: null,
                    },
                    share_percentage: tr.share_percentage * 10,
                    role_type: 2,
                    email: null,
                    person_type: null,
                    isValid: true,
                    is_max_percentage: null,
                    id: tr.id,
                    loan_id: this.loanData.id
                    
                };
                if(isValid) {
                    if(isMoral) {
                        // console.log(tr);
                        this.selectedStakeholder.profile.name = tr.business_profile.name;
                        this.selectedStakeholder.profile.rfc = tr.business_profile.rfc;
                        this.selectedStakeholder.email = tr.email 
                        this.selectedStakeholder.profile.constitution_date = tr.business_profile.constitution_date;
                        this.selectedStakeholder.profile.phone_id = tr.business_profile.phone_id;
                        if(tr.business_profile.phone_id != null) {
                            this.selectedStakeholder.profile.phone = {
                                phone: tr.business_profile.phone.phone,
                                country_calling_code: tr.business_profile.phone.country_calling_code,
                            }
                        }
                        this.selectedStakeholder.person_type = "2";
                    } else {
                        this.selectedStakeholder.profile.first_name = tr.personal_profile.first_name;
                        this.selectedStakeholder.profile.second_name = tr.personal_profile.second_name;
                        this.selectedStakeholder.profile.last_name_1 = tr.personal_profile.last_name_1;
                        this.selectedStakeholder.profile.last_name_2 = tr.personal_profile.last_name_2;
                        this.selectedStakeholder.person_type = "1";
                        this.selectedStakeholder.email = tr.email                
                        this.selectedStakeholder.profile.birth_date = tr.personal_profile.birth_date;
                        this.selectedStakeholder.profile.gender = tr.personal_profile.gender;
                        this.selectedStakeholder.profile.birth_state = tr.personal_profile.birth_state;
                        this.selectedStakeholder.profile.rfc = tr.personal_profile.rfc;
                        this.selectedStakeholder.profile.curp = tr.personal_profile.curp;
                        this.selectedStakeholder.profile.citizenship = tr.personal_profile.citizenship;
                        this.selectedStakeholder.profile.phone_id = tr.personal_profile.phone_id;
                        if(tr.personal_profile.phone_id != null) {
                            this.selectedStakeholder.profile.phone = {
                                phone: tr.personal_profile.phone.phone,
                                country_calling_code: tr.personal_profile.phone.country_calling_code,
                            }
                        }
                    }
                    this.isEditing = true;
                    this.showFormPrompt = true;
                } else {
                    this.missingFieldsNotif(null, "Este accionista se creó de manera erronea, sugiero eliminar.");
                }
            },
            async stakeholderUpdated() {
                // console.log("stakeholderUpdated")
                this.showLoading(true);
                this.isMounted = false;
                this.stakeholdersArray = [];
                this.addStakeholder();
                this.isEditing = false;
                this.showFormPrompt = false;
                await this.$emit("updated");
                this.isMounted = true;
                this.$forceUpdate();
                this.showLoading(false);
            },
            getDate(stakeholder) {
                if(stakeholder.stakeholder_bp_id != null) {
                    return this.humanizedCompactDate(stakeholder.business_profile.constitution_date);
                } else if(stakeholder.stakeholder_pp_id != null) {
                    const personal = stakeholder.personal_profile; 
                    return this.humanizedCompactDate(personal.birth_date);
                } else {
                    return "NO TIENE PERFIL";
                }
            },
            async setRepLegalAsStakeholder() {
                try {
                    this.showLoading(true);
                    const res = await axios.post(`/api/stakeholder/post/${this.loanData.id}/set-legal-rep-stakeholder`, {
                        action: this.replegal_value,
                        share_percentage: this.replegal_value == 1 ? this.repLegalPercentage : null
                    });
                    this.showRepLegalInfo = false;
                    await this.$emit("updated");
                    this.showLoading(false);
                } catch (error) {
                    console.error(error);
                    this.showLoading(false);
                    this.failedOperationNotif();
                } finally {
                    this.showLoading(false);
                }
            },
            hasError(val) {
                return this.errors.has(val);
            },
            errorText(val) {
                return this.errors.first(val);
            },
            isSuccess(val) {
                let ff = this.fields[val];
                return ff && ff.required && ff.valid;
            },
        }
    }
</script>